/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * system object
 * @export
 * @interface PostUniverseIdsSystem
 */
export interface PostUniverseIdsSystem {
    /**
     * id integer
     * @type {number}
     * @memberof PostUniverseIdsSystem
     */
    id?: number;
    /**
     * name string
     * @type {string}
     * @memberof PostUniverseIdsSystem
     */
    name?: string;
}

/**
 * Check if a given object implements the PostUniverseIdsSystem interface.
 */
export function instanceOfPostUniverseIdsSystem(value: object): value is PostUniverseIdsSystem {
    return true;
}

export function PostUniverseIdsSystemFromJSON(json: any): PostUniverseIdsSystem {
    return PostUniverseIdsSystemFromJSONTyped(json, false);
}

export function PostUniverseIdsSystemFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostUniverseIdsSystem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function PostUniverseIdsSystemToJSON(json: any): PostUniverseIdsSystem {
    return PostUniverseIdsSystemToJSONTyped(json, false);
}

export function PostUniverseIdsSystemToJSONTyped(value?: PostUniverseIdsSystem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

